import api from '../utils/api'

export const createRequest = async (request) => {
    
    try {

        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        
        const body = {
            reLegalSolicitante: request.reLegalSolicitante,
            uf: request.uf ,
            respUsuario: request.respUsuario ,
            codSap: request.codSap ,
            // codSap2: request.codSap2 ,
            nomeEquipamento: request.nomeEquipamento ,
            fabricanteEquipamento: request.fabricanteEquipamento ,
            partNumberEquipamento: request.partNumberEquipamento ,
            familiaEquipamento: request.familiaEquipamento ,
            grupoProdutoEquipamento: request.grupoProdutoEquipamento ,
            equipamentos: request.equipamentos,
            isMultipleEquipamentos: request.isMultipleEquipamentos,
            // respSap: request.respSap ,
            quantidade: request.quantidade ,
            tipoPlanta: request.tipoPlanta ,
            idBoleto: request.idBoleto ,
            tipoBoleto: request.tipoBoleto ,
            tipoAtendimento: request.tipoAtendimento ,
            dataHoraProgramado: request.dataHoraProgramado ,
            site: request.site ,
            gmo: request.gmo ,
            drsOriginal: request.drsOriginal ,
            fct: request.fct ,
            tecnico: request.tecnico,
            reTecnico: request.reTecnico,
            empresaTecnico: request.empresaTecnico,
            telefone: request.telefone,
            enderecoEntrega: request.enderecoEntrega,
            cidadeEntrega: request.cidadeEntrega,
            enderecoEntregaComplemento: request.enderecoEntregaComplemento,
            observacao: request.observacao ,
            comentarioGestao: request.comentarioGestao,
            isReplica: request.isReplica,
            sgrsNumber: request.sgrsNumber,
            sgrsAbertoEm: request.sgrsAbertoEm,
            bbnAbertoEm: request.bbnAbertoEm,
            // createReverse: request.createReverse,
        }

        if (request.isFurtoVandalismo === true) {
            body.isFurtoVandalismo = true;
        }

        if (request.qtdFurtoVandalismo != null && Number(request.qtdFurtoVandalismo) > 0) {
            body.qtdFurtoVandalismo = Number(request.qtdFurtoVandalismo);
        }

        const data = await api.post('/requests/create', body).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
    
}

export const getRequest = async (filter, currentPage, itemsPerPage, isReport) => {

    const limitDefault = itemsPerPage || 5; // quantidade por página default

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/requests';
        
        if (filter) {
            if(isReport)
                url += `${filter}&isreport=true`
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
            
        } else {
            if(isReport)
                url += `?isreport=true`
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        // Verifica se o erro é 401 (Token inválido ou expirado)
        if (error.response?.status === 401) {
            // Limpa o token e redireciona o usuário para o login
            localStorage.removeItem("token");
            window.location.href = "/login"; // Redireciona para o login
        }

        // return error; // Relança o erro para ser tratado caso necessário
        throw new Error(error.response.data.message);
    }
}

export const getRequestsEntregador = async (filter, currentPage, itemsPerPage, isReport) => {

    const limitDefault = itemsPerPage || 5; // quantidade por página default

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/requests/get-req-entregador';
        
        if (filter) {
            if(isReport)
                url += `${filter}&isreport=true`
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
            
        } else {
            if(isReport)
                url += `?isreport=true`
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        // Verifica se o erro é 401 (Token inválido ou expirado)
        if (error.response?.status === 401) {
            // Limpa o token e redireciona o usuário para o login
            localStorage.removeItem("token");
            window.location.href = "/login"; // Redireciona para o login
        }

        return error; // Relança o erro para ser tratado caso necessário
    }
}

// Monitor: as 6 listas de status numa única chamada. Antes eram 6 requisições
// paralelas, cada uma com seu próprio ciclo de atualização.
export const getMonitorLists = async () => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const { data } = await api.get('/requests/monitor');
        return data?.listas || null;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return null;
    }
};

export const calculateSummary = async () => {
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/requests/calculateSummary`).then((response) => {
            return response.data
        })

        return data

    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;
    }
}

export const updateParcial = async (requestId, body) => {
    console.log(body)
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.patch(`/requests/${requestId}`, body).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
        
    }
}

// ── Portal de Justificativas — resumo (cards de dashboard) ──
// query opcional (ex.: '?regra=todos'). Retorna contagens + aging buckets.
export const summaryJustificativas = async (query = '') => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        const data = await api.get(`/requests/justificativa/summary${query}`).then((response) => response.data)
        return data
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao carregar resumo.');
    }
}

// ── Portal de Justificativas — listagem unificada ──
// Lista os chamados do mês que precisam de justificativa (filtro único no backend).
// `filter` é uma query string opcional (ex.: '?statusjustificativa=JUSTIFICAR').
export const getRequestsJustificativas = async (filter, currentPage, itemsPerPage, isReport) => {
    const limitDefault = itemsPerPage || 15;
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/requests/justificativa/list';
        if (filter) {
            url += isReport ? `${filter}&isreport=true` : `${filter}&page=${currentPage}&limit=${limitDefault}`;
        } else {
            url += isReport ? `?isreport=true` : `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => response.data);
        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        throw new Error(error.response?.data?.message || 'Erro ao listar justificativas.');
    }
}

// ── Portal de Justificativas — faixa calculada (drsAtender x drsOriginal) ──
// Retorna { faixa, drsAtender, drsOriginal, dentroArea }. faixa pode ser null.
export const getFaixaJustificativa = async (requestId) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        const data = await api.get(`/requests/justificativa/faixa/${requestId}`).then((response) => response.data)
        return data
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao calcular faixa.');
    }
}

// ── Portal de Justificativas — transições de workflow ──

// Amerinode justifica/replica (JUSTIFICAR|EM_REPLICA → AGUARDANDO_APROVACAO).
// body: { justificativa, motivo, somenteFaturamento }
export const justificarRequest = async (requestId, body) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        const data = await api.patch(`/requests/justificativa/justificar/${requestId}`, body).then((response) => response.data)
        return data
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao justificar.');
    }
}

// Amerinode desiste da réplica (EM_REPLICA → RECUSADO). body: { comentario? }
export const desistirJustificativa = async (requestId, body) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        const data = await api.patch(`/requests/justificativa/desistir/${requestId}`, body || {}).then((response) => response.data)
        return data
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao desistir da réplica.');
    }
}

// Vivo avalia (AGUARDANDO_APROVACAO → ACEITO|ABONADO|EM_REPLICA).
// body: { decisao: 'ACEITAR'|'ABONAR'|'RECUSAR', observacaoVivo }
export const avaliarJustificativa = async (requestId, body) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
        const data = await api.patch(`/requests/justificativa/avaliar/${requestId}`, body).then((response) => response.data)
        return data
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao avaliar justificativa.');
    }
}

export const changeCodSapAlternativo = async (requestId, body) => {
    console.log(body)
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.patch(`/requests/change-sap-alternativo/${requestId}`, body).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
        
    }
}

export const cancelRequest = async (requestId, body) => {

    const response = await getRequestById(requestId, body)

    // console.log(response.request)
    // console.log(response.request.status)

    if (response.request.isReplica) {
        console.log("ENTROU")
        try {

            const token = localStorage.getItem('token');

            api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

            const data = await api.delete(`/requests/${requestId}`, body).then((response) => {
                return response.data
            })

            return data

        } catch (error) {

            throw new Error(error.response.data.message);

        }
    } else {

        console.log("OUTRO")

        if(response && (response.request.status === 'NOVO' ||  response.request.status === 'GESTAO')){
            // console.log(body)
            try {
    
                const token = localStorage.getItem('token');
            
                api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
    
                const data = await api.patch(`/requests/cancelbyid/${requestId}`, body).then((response) => {
                    return response.data
                })
    
                return data
                
            } catch (error) {
    
                throw new Error(error.response.data.message);
                
            }
        } else {
            return null
        }
        
    }

    
}

export const getRequestById = async (requestId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/requests/${requestId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {
        if (error.response?.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return error;     
    }
}

export const getMyRequests = async (filter, currentPage, itemsPerPage, isReport) => {

    const limitDefault = itemsPerPage || 5; // quantidade por página default

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/requests/myrequests';
        
        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
            
        } else {
            if (isReport)
                url += `?isreport=true`
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            // Limpa o token e redireciona o usuário para o login
            localStorage.removeItem("token");
            window.location.href = "/login"; // Redireciona para o login
        }

        return error; // Relança o erro para ser tratado caso necessário
    }
}

export const getMyCompanyRequests = async (filter, currentPage, itemsPerPage, isReport) => {

    const limitDefault = itemsPerPage || 5; // quantidade por página default

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/requests/companyrequests';
        
        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
            
        } else {
            if (isReport)
                url += `?isreport=true`
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
}

export const addItemToRequest = async (requestId, item) => {
    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const body = { item };

        const response = await api.patch(`/requests/additem/${requestId}`, body);
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
    }
};

export const removeItemFromRequest = async (requestId, item) => {
    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const body = { item };

        const data = await api.patch(`/requests/removeitem/${requestId}`, body).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
};

export const cancelDesdobramentos = async (requestId) => {

    const response = await getRequestById(requestId)

    console.log(response.request)
    console.log(response.request.status)

    if(response && (response.request.status === 'GESTAO' || response.request.status === 'NOVO')){
        try {

            const token = localStorage.getItem('token');
        
            api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

            const data = await api.post(`/requests/cancelDesdobramentos/${requestId}`).then((response) => {
                return response.data
            })

            return data
            
        } catch (error) {

            throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
            
        }
    } else {
        throw new Error("Requisições precisam estar no Backoffice ou em Gestão!"); // Lança uma exceção com a mensagem de erro do servidor
    }
}

export const changeEntregador = async (requestId, entregadorData) => {
  try {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    const data = await api.patch(`/requests/change-entregador/${requestId}`, entregadorData).then((response) => {
      return response.data;
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao trocar entregador");
  }
};

export const encerramentoTecnico = async (requestId, body) => {
  try {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    const data = await api.patch(`/requests/encerramento/${requestId}`, body).then((response) => {
      return response.data;
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao encerrar tecnicamente.");
  }
};

// NOVAS FUNÇÕES DE UPDATE ISOLADAS
export const sendToDeliveryRoute = async (requestId, body) => {
  try {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    const data = await api.patch(`/requests/send-to-delivery-route/${requestId}`, body).then((response) => {
      return response.data;
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao enviar para rota de entrega.");
  }
};

export const sendToDelivery = async (requestId, body) => {
  try {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    const data = await api.patch(`/requests/send-to-delivery/${requestId}`, body).then((response) => {
      return response.data;
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao registrar entrega.");
  }
};

export const getQualificationReport = async (filter) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        const data = await api.get(`/requests/pendencias-qualificacao`, filter).then((response) => {
            return response.data;
        });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Erro ao gerar relatório de qualificação.");
    }
};

export const updateQualificacao = async (requestId, qualificacaoData) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        const data = await api.patch(`/requests/qualificacao/${requestId}`, qualificacaoData).then((response) => {
            return response.data;
        });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Erro ao atualizar qualificação.");
    }
};


const RequestService = {
    createRequest,
    getRequest,
    getRequestsEntregador,
    updateParcial,
    changeCodSapAlternativo,
    getRequestById,
    getMyRequests,
    getMyCompanyRequests,
    cancelRequest,
    addItemToRequest,
    removeItemFromRequest,
    cancelDesdobramentos,
    calculateSummary,
    getMonitorLists,
    changeEntregador,
    encerramentoTecnico,
    sendToDeliveryRoute,
    sendToDelivery,
    getQualificationReport,
    updateQualificacao,
    getRequestsJustificativas,
    summaryJustificativas,
    getFaixaJustificativa,
    justificarRequest,
    desistirJustificativa,
    avaliarJustificativa
  };

  export default RequestService;